export const products = [
  {
    id: 3,
    img: './images/sikimoto.png',
    link: 'https://sikimoto-app.netlify.app',
  },

  {
    id: 5,
    img: './images/mssrbija.png',
    link: 'https://mssrbija.netlify.app',
  },

  {
    id: 7,
    img: './images/recepti.png',
    link: 'https://devox-recepti.netlify.app',
  },
  {
    id: 8,
    img: './images/kameleon.png',
    link: 'https://sala-ketering-kameleon.com',
  },
  {
    id: 9,
    img: './images/ciklogen-next.png',
    link: 'https://ciklogen-next.vercel.app',
  },
  {
    id: 1,
    img: './images/ask23.png',
    link: 'https://ask23.rs/',
  },
  {
    id: 2,
    img: './images/devox-notes.png',
    link: 'https://devox-notes.netlify.app/',
  },
];
